<script lang="ts">
	import { getSafeSrc } from '@repo/commons/utils'

	interface Props {
		imageSrc: string | null
		fallback?: string
		className?: string
		imageWithGradientBg?: boolean
		isLoading?: boolean
		size?: 'sm' | 'md' | 'lg'
	}

	let {
		imageSrc,
		fallback = '',
		imageWithGradientBg = false,
		className = '',
		isLoading = false,
		size = undefined
	}: Props = $props()

	const sizeClass = $derived(size ? `avatar-size-${size}` : '')
	let failedImageSrc = $state<string | null>(null)
	const imageError = $derived(imageSrc === failedImageSrc)

	function handleImageError() {
		failedImageSrc = imageSrc
	}

	function getGradientVariant(text: string): number {
		if (!text || text.length === 0) return 0
		const charCode = text.charCodeAt(0)
		return charCode % 6 // Returns 0-5 for 6 gradient variants
	}

	const gradientClass = $derived.by(() => `gradient-${getGradientVariant(fallback)}`)
</script>

{#if imageSrc && !imageError}
	<img
		src={getSafeSrc(imageSrc, 'image')}
		alt=""
		class="item-img {sizeClass} {className} {imageWithGradientBg ? gradientClass : ' '}"
		class:loading={isLoading}
		onerror={handleImageError}
	/>
{:else}
	<div class="fallback-wrapper {sizeClass} {gradientClass} {className}" class:loading={isLoading}>
		{fallback}
	</div>
{/if}

<style>
	.item-img {
		@apply rounded-full;
	}

	.loading {
		@apply animate-pulse;
	}

	.fallback-wrapper {
		@apply flex items-center justify-center w-full h-full max-w-16 border border-[#003A661A] rounded-full text-lg text-[#001D33B2] font-semibold overflow-hidden;
		aspect-ratio: 1 / 1;
	}

	.gradient-0 {
		background: linear-gradient(180deg, #fff5e5 0%, #ffe3cc 100%);
	}

	.gradient-1 {
		background: linear-gradient(180deg, #edffe6 0%, #d1fad7 100%);
	}

	.gradient-2 {
		background: linear-gradient(180deg, #e5eeff 0%, #ceccff 100%);
	}

	.gradient-3 {
		background: linear-gradient(180deg, #e5f7ff 0%, #cceaff 100%);
	}

	.gradient-4 {
		background: linear-gradient(180deg, #fcffe5 0%, #f8ffcc 100%);
	}

	.gradient-5 {
		background: linear-gradient(180deg, #ffe5e5 0%, #ffcccc 100%);
	}

	.avatar-size-sm {
		width: 2rem;
		height: 2rem;
		object-fit: cover;
	}

	.avatar-size-md {
		width: 3rem;
		height: 3rem;
		object-fit: cover;
	}

	.avatar-size-lg {
		width: 4rem;
		height: 4rem;
		object-fit: cover;
	}
</style>
